import { Navigate, Route, Routes } from "react-router";

import { AdminRoute, ProtectedRoute } from "@/components/protected-route";
import { AdminActivityPage } from "@/features/admin/activity";
import { AdminUsersPage } from "@/features/admin/users";
import { DashboardIndexRedirect, DashboardPage } from "@/features/dashboard";
import { AfgerondPage } from "@/features/dashboard/pages/afgerond";
import { AiRegelsPage } from "@/features/dashboard/pages/ai-regels";
import { AuditPage } from "@/features/dashboard/pages/audit";
import { BureauPage } from "@/features/dashboard/pages/bureau";
import { DossiersPage } from "@/features/dashboard/pages/dossiers";
import { InstellingenPage } from "@/features/dashboard/pages/instellingen";
import { OverviewPage } from "@/features/dashboard/pages/overview";
import { PrescreeningPage } from "@/features/dashboard/pages/prescreening";
import { TeamAanvragenPage } from "@/features/dashboard/pages/promoter/team-aanvragen";
import { AanvraagDetailPage } from "@/features/dashboard/pages/researcher/aanvraag-detail";
import { HoeWerktHetPage } from "@/features/dashboard/pages/researcher/hoe-werkt-het";
import { MijnAanvragenPage } from "@/features/dashboard/pages/researcher/mijn-aanvragen";
import { NieuweAanvraagPage } from "@/features/dashboard/pages/researcher/nieuwe-aanvraag";
import { VraagbaakPage } from "@/features/dashboard/pages/researcher/vraagbaak";
import { SecretariaatPage } from "@/features/dashboard/pages/secretariaat";
import { HomePage } from "@/features/home";
import { LoginPage } from "@/features/login";
import { NotFoundPage } from "@/features/not-found";
import { ProfilePage } from "@/features/profile";
import { SignupPage } from "@/features/signup";
import { VerifyEmailPage } from "@/features/verify-email";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/home" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<HomePage />} />
        <Route path="/dashboard" element={<DashboardPage />}>
          <Route index element={<DashboardIndexRedirect />} />
          <Route path="overview" element={<OverviewPage />} />
          <Route path="dossiers" element={<DossiersPage />} />
          <Route path="prescreening" element={<PrescreeningPage />} />
          <Route path="secretariaat" element={<SecretariaatPage />} />
          <Route path="bureau" element={<BureauPage />} />
          <Route path="afgerond" element={<AfgerondPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="instellingen" element={<InstellingenPage />} />
          <Route path="ai-regels" element={<AiRegelsPage />} />
          <Route path="mijn-aanvragen" element={<MijnAanvragenPage />} />
          <Route path="nieuwe-aanvraag" element={<NieuweAanvraagPage />} />
          <Route path="aanvraag-detail" element={<AanvraagDetailPage />} />
          <Route path="vraagbaak" element={<VraagbaakPage />} />
          <Route path="hoe-werkt-het" element={<HoeWerktHetPage />} />
          <Route path="team-aanvragen" element={<TeamAanvragenPage />} />
        </Route>
        <Route path="/profile" element={<ProfilePage />} />
      </Route>
      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/activity" element={<AdminActivityPage />} />
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
